import { useStore } from '../../lib/hooks/useStore';
import { AppIconType } from '../../lib/typegen/app-icon-type';
import { ConfirmServerProps } from '../../lib/typegen/confirm-server-props';
import GenericButton from '../button-generic';
import style from './style.module.scss';

export interface ConfirmProps extends React.ButtonHTMLAttributes<HTMLDialogElement>, Partial<ConfirmServerProps> {
	noCallback?: () => void;
	yesCallback?: () => void;
}

export default function Confirm({ titleLabel, questionLabel, yesButton, yesCallback, noButton, noCallback, className, ...props }: ConfirmProps) {
	const {
		uiStore: { handleNavigation },
		configStore: { getString },
	} = useStore();
	return (
		<dialog open {...props} className={[className, style.dialog].join(' ')}>
			<hgroup className={[style.dialog__text, style.text].join(' ')}>
				{titleLabel && <h2 className={style.text__title}>{getString(titleLabel)}</h2>}
				{questionLabel && <p className={style.text__question}>{getString(questionLabel)}</p>}
			</hgroup>
			<menu className={[style.dialog__actions, style.actions].join(' ')}>
				{noButton && (
					<li className={style.actions__no}>
						<GenericButton
							className={style.actions__button}
							icon={AppIconType.CancelSolid}
							isAltColor={true}
							innerText={getString(noButton.label)}
							defaultValue={noButton.value}
							isGrowHorizontally={false}
							onClick={() => {
								if (noButton.target) handleNavigation(noButton.target);
								noCallback?.();
							}}
						/>
					</li>
				)}
				{yesButton && (
					<li className={[style.actions__yes, !noButton ? style['actions__yes--extended'] : ''].join(' ')}>
						<GenericButton
							className={style.actions__button}
							icon={AppIconType.AcceptSolid}
							innerText={getString(yesButton.label)}
							defaultValue={yesButton.value}
							isGrowHorizontally={!noButton}
							onClick={() => {
								if (yesButton.target) handleNavigation(yesButton.target);
								yesCallback?.();
							}}
							style={!noButton ? { width: '100%', justifyContent: 'center' } : {}}
							hasGlow={true}
							centeredContent={!noButton}
						/>
					</li>
				)}
			</menu>
		</dialog>
	);
}
